import React from 'react';

import { BASE_COLOR as BC } from 'shared/constants/colors';
import { animateFadeInSlow } from 'shared/styles';


const Placeholder = ({children, style = {}, ...rest}) => {
  const props = {
    spellCheck: false,
    contentEditable: false,
    style: {
      pointerEvents: 'none',
      maxWidth: '100%',
      position: 'absolute',
      whiteSpace: 'nowrap',
      color: BC.moonGray,
      ...animateFadeInSlow,
      ...style,
    },
  };

  return (
    <span {...props} {...rest}>
      {children}
    </span>
  );
};


export default Placeholder;



// WEBPACK FOOTER //
// ./src/components/slate/Placeholder.js